import { createReducer } from "@reduxjs/toolkit";

import {
  getCreatorStreams,
  getCreatorStreamsSuccess,
  getCreatorStreamsFailure,
  updateCreatorStreamReminder,
  clearCreatorStreams,
} from "./actions";

/**
 * @property {object[]} livestreams array of creator livestreams
 * @property {number} totalCount total number of creator livestreams
 * @property {boolean} isLoading flag to indicate if the request is in progress
 * @property {string | null} error error message
 * @property {number | null} nextOffset offset to fetch the next set of creator livestreams
 */
const initialState = {
  livestreams: [],
  totalCount: null,
  isLoading: true,
  error: null,
  nextOffset: null,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getCreatorStreams.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(getCreatorStreamsSuccess.type, (state, action) => {
      return {
        ...state,
        ...action.payload,
        livestreams: [...state.livestreams, ...action.payload.livestreams],
        error: initialState.error,
        isLoading: false,
      };
    })
    .addCase(getCreatorStreamsFailure.type, (state, action) => ({
      ...state,
      error: action.payload,
      isLoading: false,
    }))
    .addCase(updateCreatorStreamReminder.type, (state, action) => {
      const index = state.livestreams.findIndex(
        (stream) => stream.uniqueKey === action.payload,
      );
      const streams = [...state.livestreams];
      if (index !== -1) {
        streams.splice(index, 1, {
          ...streams[index],
          isReminderSet: true,
        });
      }
      return {
        ...state,
        livestreams: streams,
      };
    })
    .addCase(clearCreatorStreams.type, () => ({
      ...initialState,
    }));
});
